export enum MobilePlatform {
    iOS = 'ios',
    android = 'android'
}